import React from 'react'
import { Table } from 'react-bootstrap'

const ShipmentParcelList = ({ shipment }) => (
  <div>
    <Table border="3">
      <thead border="2">
        <tr>
          <td colSpan="2">Contents : </td>
          <td>Containers :</td>
        </tr>
      </thead>
      {shipment.dewarVOs
        .sort((a, b) => a.dewarId - b.dewarId)
        .map(parcel => (
          <tbody border="2" key={parcel.dewarId}>
            <tr>
              <td>Name : </td>
              <td>{parcel.code}</td>
              <td rowSpan="4">{parcel.containerVOs.map(container => container.code)}</td>
            </tr>
            <tr>
              <td>Status : </td>
              <td>{parcel.dewarStatus}</td>
            </tr>
            <tr>
              <td>Location : </td>
              <td>{shipment.sessions[0].beamlineName}</td>
            </tr>
            <tr>
              <td>Storage : </td>
              <td>{parcel.storageLocation}</td>
            </tr>
          </tbody>
        ))}
    </Table>
  </div>
)

export default ShipmentParcelList
